export default __webpack_public_path__ + "static/Graphik-Regular-Web-ee9d67fff7cbd37d8404e6ea92796404.eot";